import React from "react";
import {Link} from "gatsby";
// @ts-ignore
import sitemap from "../data/sitemap.json";
// @ts-ignore
import logo from "../images/logo-blue.png";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem} from "reactstrap";

interface HeaderProps {
	children: React.ReactNode
}

interface HeaderState {
	navOpen: boolean;
}

export default class extends React.Component<HeaderProps, HeaderState> {

	constructor(props: HeaderProps) {
		super(props);
		this.state = {
			navOpen: false
		};
	}

	render() {
		return (
			<div className="banner">
				<header className="container-fluid">
					<Navbar light expand="lg">
						<NavbarBrand href={sitemap.index}><img src={logo} alt=""/></NavbarBrand>
						<NavbarToggler onClick={() => this.setState({navOpen: !this.state.navOpen})}/>
						<Collapse isOpen={this.state.navOpen} navbar>
							<Nav className="mr-auto" navbar>
								<NavItem>
									<Link to="/" className="nav-link" activeClassName="active">
										HOME
									</Link>
								</NavItem>
								<NavItem>
									<Link to={sitemap.certificates} className="nav-link" activeClassName="active">
										QUALITY CERTIFICATES
									</Link>
								</NavItem>
								<NavItem>
									<Link to={sitemap.environmentalPolicy} className="nav-link" activeClassName="active">
										ENVIRONMENTAL POLICY
									</Link>
								</NavItem>
								<NavItem>
									<Link to={sitemap.demo} className="nav-link" activeClassName="active">
										DEMO
									</Link>
								</NavItem>
								<NavItem>
									<Link to={sitemap.pricing} className="nav-link" activeClassName="active">
										PRICING
									</Link>
								</NavItem>

								{/*<NavItem>
									<a href="https://kys.sono.com.tr" className="nav-link">
										TÜRKÇE
									</a>
								</NavItem>*/}
							</Nav>
							<Nav className="ml-auto social" navbar>
								<NavItem>
									<a className="nav-link"
									   href="https://www.linkedin.com/company/sono-yazilim-anonim-sirketi/"
									   target="_blank">
										<i className="fab fa-linkedin-in"/>
									</a>
								</NavItem>
								<NavItem>
									<a className="nav-link" href="https://twitter.com/sonoyazilim" target="_blank">
										<i className="fab fa-twitter"/>
									</a>
								</NavItem>
								<NavItem>
									<a className="nav-link" href="https://www.facebook.com/sonoyazilim/"
									   target="_blank">
										<i className="fab fa-facebook-f"/>
									</a>
								</NavItem>
							</Nav>
						</Collapse>
					</Navbar>
				</header>

				{this.props.children}
			</div>
		);
	}
}
